// removed by extract-text-webpack-plugin
module.exports = {"button":"hkdNt","fixedWidth":"_15YWe","primary":"_2JTMf","large":"juEZX"};